export default __webpack_public_path__ + "static/media/cog.9b181404.svg";